import script from "./AgentFloatingWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentFloatingWidget.vue?vue&type=script&setup=true&lang=js"

import "./AgentFloatingWidget.vue?vue&type=style&index=0&id=4d676254&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d676254"]])

export default __exports__